<script lang="ts">
  import { link } from "svelte-routing"
  import Image from "./Image.svelte"
  import { multipliers, rounds, tokenPrice } from "../stores/store"
  import { nFormatter } from "../utils/utils"
  import PilTooltip from "./PilTooltip.svelte"
  import WithdrawModal from "./WithdrawModal.svelte"

  export let data = [];
  let columns = ['Item', 'Title', 'Round Value', 'PIL APR', 'Multiplier', 'Action'];

  let tooltips = {
    'Round Value': 'current price per round * num of rounds you own. The actual return of this position could be different.',
    'PIL APR': 'Annualized PIL returns from this pool.',
    'Multiplier': 'Rewards multiplier over base PIL emissions for this pool.',
  }
</script>

<table class="pil-table">
  <thead>
    <tr>
      {#each columns as column}
        <th class={'table-header ' + (column === 'Title' ? 'table-title' : '')}>
          {column}
          {#if tooltips.hasOwnProperty(column)}
            <PilTooltip tooltipId={`pos-round-${column.replace(/ /i, '-')}`}>{tooltips[column]}</PilTooltip>
          {/if}
        </th>
      {/each}
    </tr>
  </thead>
  <tbody>
  {#each data as row}
    <tr>
      <td class="table-thumbnail-col">
        <a href={`/nft/${row.metaNftId}`} use:link>
          <Image src={row.image} table={true}/>
        </a>
      </td>
      <td class='table-title'>
        <a class="table-title-link" href={`/nft/${row.metaNftId}`} use:link>
          {row.title}
        </a>
      </td>
      <td>
        {nFormatter(row.roundValue, 2)} {row.baseToken}
        {#if row.roundValueDeltaRate === Infinity}
          <span class="positive">
            &nbsp;&nbsp;+{nFormatter(row.roundValueDelta, 2)} (Infinity %)
          </span>
        {:else if row.roundValueDelta >= 0}
          <span class="positive">
            &nbsp;&nbsp;+{nFormatter(row.roundValueDelta, 2)} ({row.roundValueDeltaRate.toFixed(2)}%)
          </span>
        {:else}
          <span class="negative">
            &nbsp;&nbsp;-{nFormatter(row.roundValueDelta, 2)} ({(row.roundValueDeltaRate * -1).toFixed(2)}%)
          </span>
        {/if}
        <!--<span class={row['Round Value'].delta > 0 ? 'positive' : 'negative'}>-->

<!--        </span>-->
      </td>
      <td>
        {nFormatter(row.yearPairRewardPerRound * $tokenPrice.PIL / (row.averageCost * $tokenPrice[row.baseToken]) * 100, 2)}%
      </td>
      <td>
        {$multipliers[row.baseToken]}x
      </td>
      <td>
        {#if !row.activated}
          <WithdrawModal action="refund" data={row}/>
        {/if}
      </td>
    </tr>
  {/each}
  </tbody>
</table>
